import type { FormApi } from './form.types.js';
import { createFormRuntime } from './runtime/createFormRuntime.js';

/**
 * Creates a `FormApi` outside a React render. Use this when you need a form
 * handle in module scope, a non-React callback, or a store that outlives the
 * component. Inside a React component, prefer `_useForm` for a stable
 * reference across renders.
 *
 * Pass the returned handle to the `form` prop of `<Form>` so the component
 * uses this runtime instead of creating its own.
 * @internal
 */
export function createForm<
  TValues = Record<string, unknown>,
>(): FormApi<TValues> {
  return createFormRuntime<TValues>() as FormApi<TValues>;
}
